import React, { FC } from 'react';
import styled from 'styled-components';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { OrderBy } from '../../../common/types';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvSortableColumnHeaderProps {
  label: string;
  sortBy: string;
  activeOrderBy: string;
  activeOrderDir: string;
  onSort: (order: OrderBy) => void;
}

const OvSortableColumnHeader: FC<OvSortableColumnHeaderProps> = ({
  label,
  sortBy,
  activeOrderBy,
  activeOrderDir,
  onSort,
}) => {
  const isActive = activeOrderBy === sortBy;
  const isAscending = isActive && activeOrderDir === 'asc';

  const getAriaSort = () => {
    if (!isActive) {
      return 'none';
    }

    return isAscending ? 'ascending' : 'descending';
  };

  return (
    <th scope="col" aria-sort={getAriaSort()}>
      <SortButton
        type="button"
        onClick={() =>
          onSort({ order_by: sortBy, order_dir: isAscending ? 'desc' : 'asc' })
        }
      >
        {label}
        {isActive &&
          (isAscending ? (
            <ArrowUpwardIcon aria-hidden="true" />
          ) : (
            <ArrowDownwardIcon aria-hidden="true" />
          ))}
      </SortButton>
    </th>
  );
};

export default OvSortableColumnHeader;

const SortButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  min-height: 1.875rem;
  padding: 0;
  border: 0;
  border-radius: ${Variables.borderRadius.SMALL};
  background: none;
  color: inherit;
  font: inherit;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${Colours.OV_BASE};
  }

  &:focus-visible {
    outline: 3px solid ${Colours.OV_ACCENT_BLUE};
    outline-offset: 2px;
  }

  .MuiSvgIcon-root {
    width: 0.875rem;
    height: 0.875rem;
  }
`;
